import React from 'react';

import styles from './DonutLabelList.module.css';

type DonutLabelItemProps = {
  icon: React.ReactNode;
  label: string;
  value: number | string;
};

export const DonutLabelItem = ({ icon, label, value }: DonutLabelItemProps) => {
  return (
    <li className={styles.item}>
      <div className={styles.itemLabelContent}>
        {icon}
        <span className={styles.label}>{label}</span>
      </div>
      <span className={styles.value}>{value}</span>
    </li>
  );
};

DonutLabelItem.displayName = 'DonutLabelItem';

type DonutLabelListProps = {
  items: DonutLabelItemProps[];
};

export const DonutLabelList = ({ items }: DonutLabelListProps) => {
  return (
    <ul className={styles.list}>
      {items.map((item) => (
        <DonutLabelItem key={item.label} {...item} />
      ))}
    </ul>
  );
};
